import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === "POP") return;

    let frame: number;
    const deadline = Date.now() + 500;

    const enforceTop = () => {
      if (window.scrollY !== 0 || window.scrollX !== 0) {
        window.scrollTo(0, 0);
      }
      if (Date.now() < deadline) {
        frame = requestAnimationFrame(enforceTop);
      }
    };

    frame = requestAnimationFrame(enforceTop);

    return () => cancelAnimationFrame(frame);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, navigationType]);

  return null;
};

export default ScrollToTop;
